import { useState, useEffect } from 'react';

type DeviceType = {
  isMobile: boolean;
  isAndroid: boolean;
  isIPhone: boolean;
  deviceType: 'android' | 'iphone' | 'other' | 'desktop';
};

const useDeviceDetect = (): DeviceType => {
  const [deviceData, setDeviceData] = useState<DeviceType>({
    isMobile: false,
    isAndroid: false,
    isIPhone: false,
    deviceType: 'desktop'
  });

  useEffect(() => {
    const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    
    const isAndroid = Boolean(userAgent.match(/Android/i));
    const isIPhone = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
    const isMobile = isAndroid || isIPhone || Boolean(userAgent.match(
      /BlackBerry|Opera Mini|IEMobile|WPDesktop/i
    ));

    let deviceType: DeviceType['deviceType'] = 'desktop';
    if (isAndroid) deviceType = 'android';
    else if (isIPhone) deviceType = 'iphone';
    else if (isMobile) deviceType = 'other';

    setDeviceData({
      isMobile,
      isAndroid,
      isIPhone,
      deviceType
    });
  }, []);

  return deviceData;
};

export default useDeviceDetect;